import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useOverlayTriggerState as $9Xvoh$useOverlayTriggerState } from "@react-stately/overlays";
import { useState as $9Xvoh$useState } from "react";

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
    * Copyright 2020 Adobe. All rights reserved.
    * This file is licensed to you under the Apache License, Version 2.0 (the "License");
    * you may not use this file except in compliance with the License. You may obtain a copy
    * of the License at http://www.apache.org/licenses/LICENSE-2.0
    *
    * Unless required by applicable law or agreed to in writing, software distributed under
    * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
    * OF ANY KIND, either express or implied. See the License for the specific language
    * governing permissions and limitations under the License.
    */

function $a28c903ee9ad8dc5$export$79fefeb1c2091ac3(props) {
  var overlayTriggerState = (0, $9Xvoh$useOverlayTriggerState)(props);
  var _ref = (0, $9Xvoh$useState)(null),
    _ref2 = _slicedToArray(_ref, 2),
    focusStrategy = _ref2[0],
    setFocusStrategy = _ref2[1];
  return _objectSpread(_objectSpread({
    focusStrategy: focusStrategy
  }, overlayTriggerState), {}, {
    open: function open() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      setFocusStrategy(focusStrategy);
      overlayTriggerState.open();
    },
    toggle: function toggle() {
      var focusStrategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      setFocusStrategy(focusStrategy);
      overlayTriggerState.toggle();
    }
  });
}
export { $a28c903ee9ad8dc5$export$79fefeb1c2091ac3 as useMenuTriggerState };